import { useEffect, useState } from 'react'
import { useUpdateProduct } from '@/features/product/hooks'
import type { Product } from '@/features/product/types'

export function GeneralPanel({ product }: { product: Product }) {
  const update = useUpdateProduct()
  const [labelPl, setLabelPl] = useState(product.labelPl)
  // Kolejność elementów nie jest edytowana numerycznie w UI - wartość zachowana z modelu.
  const sortOrder = product.sortOrder
  const [isActive, setIsActive] = useState(product.isActive)
  const [error, setError] = useState<string | null>(null)
  const [saved, setSaved] = useState(false)

  useEffect(() => { setSaved(false) }, [labelPl, sortOrder, isActive])

  const submit = () => {
    setError(null)
    if (!labelPl.trim()) { setError('Nazwa nie może być pusta.'); return }
    update.mutate(
      { code: product.code, payload: { labelPl, sortOrder, isActive } },
      { onSuccess: () => setSaved(true), onError: e => setError(formatError(e)) },
    )
  }

  return (
    <div className="max-w-md flex flex-col gap-3 text-sm">
      <label className="grid gap-1">
        <span className="text-xs uppercase text-slate-500">Nazwa</span>
        <input value={labelPl} onChange={e => setLabelPl(e.target.value)} disabled={update.isPending} className="border rounded px-2 py-1" />
      </label>
      <label className="flex items-center gap-2">
        <input type="checkbox" checked={isActive} onChange={e => setIsActive(e.target.checked)} disabled={update.isPending} />
        <span>Aktywny</span>
      </label>

      {error && <p className="text-red-600 text-xs">{error}</p>}
      {saved && <p className="text-emerald-700 text-xs">✓ Zapisano</p>}

      <button
        type="button"
        onClick={submit}
        disabled={update.isPending}
        className="self-start mt-2 px-3 py-1.5 bg-sky-600 text-white rounded disabled:opacity-50"
      >
        {update.isPending ? 'Zapisywanie...' : 'Zapisz zmiany'}
      </button>
    </div>
  )
}

function formatError(err: unknown): string {
  const ax = err as { response?: { data?: { detail?: string; title?: string } } }
  return ax.response?.data?.detail ?? ax.response?.data?.title ?? 'Błąd zapisu'
}
